import { render, staticRenderFns } from "./FileEventsSingle.vue?vue&type=template&id=c1846fd4&scoped=true"
import script from "./FileEventsSingle.vue?vue&type=script&lang=js"
export * from "./FileEventsSingle.vue?vue&type=script&lang=js"
import style0 from "./FileEventsSingle.vue?vue&type=style&index=0&id=c1846fd4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1846fd4",
  null
  
)

export default component.exports